import React, { lazy, Suspense, useContext } from 'react';
import PropTypes from 'prop-types';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { graphql, createFragmentContainer } from 'react-relay';
import { FullPageWidth } from '../../components/global/FullPageWidth/FullPageWidth';

const SwatchSelector = lazy(() => import('./SwatchSelectorMain'));

const PdpSharedSwatchSelectorComponent = props => {
    const {
        currency,
        onClick,
        item,
        user,
        relay,
        transactions,
        selectedSkuId,
        showSwatchDescriptionOnHover,
        showPrice,
    } = props;
    const { isMobileWebPdpVariant } = useContext(ServerVarsContext);
    const content = (
        <Suspense fallback={''}>
            <SwatchSelector
                currency={currency}
                selectedSkuId={selectedSkuId}
                item={item}
                user={user}
                transactions={transactions}
                onClick={onClick}
                relay={relay}
                pageLayout="PDP"
                showSwatchDescriptionOnHover={showSwatchDescriptionOnHover}
                showPrice={showPrice}
                isMobileWebPdpVariant={isMobileWebPdpVariant}
            />
        </Suspense>
    );
    return isMobileWebPdpVariant ? <FullPageWidth>{content}</FullPageWidth> : content;
};

PdpSharedSwatchSelectorComponent.propTypes = {
    currency: PropTypes.string,
    relay: PropTypes.object.isRequired,
    onSwatchClick: PropTypes.func,
    selectedSkuId: PropTypes.string,
    onClick: PropTypes.func,
    showSwatchDescriptionOnHover: PropTypes.bool,
    showPrice: PropTypes.bool,

    // relay response data
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
    transactions: PropTypes.object,
};
export const PdpSharedSwatchSelector = createFragmentContainer(PdpSharedSwatchSelectorComponent, {
    item: graphql`
        fragment PdpSharedSwatchSelector_item on Item {
            ...SwatchSelector_item
        }
    `,
    user: graphql`
        fragment PdpSharedSwatchSelector_user on User {
            ...SwatchSelector_user
        }
    `,
    transactions: graphql`
        fragment PdpSharedSwatchSelector_transactions on TransactionConnection {
            ...SwatchSelector_transactions
        }
    `,
});
